
export default {
    err: (m) => {
        if (typeof m == "object") {
            console.error(m);
            if (m.response) m = m.response;
            // 認証エラーの場合はログアウトさせる
            if (m.status == 401 || m.status == 419) {
                location.href = "/";
                return;
            }
            // エラーメッセージバッグはまとめる
            let message = m.data.message || m.data || m.statusText;
            if (m.data.errors instanceof Array || m.data.errors instanceof Object) {
                let errors = [];
                for (let key in m.data.errors) {
                    errors.push(m.data.errors[key]);
                }
                message = errors.join("<br>");
            } else if (m.data.errors) {
                message = m.data.errors;
            } else if (m.data.message) {
                message = m.data.message;
            } else {
                message = m.data;
            }
            m = `${m.status}: ${message}`;
        }
        $.notify({
            icon: 'fas fa-times-circle',
            message: m
        }, {
            type: "danger",
            mouse_over: "pause",
            template: `<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert">
                <button type="button" aria-hidden="true" class="btn text-reset" data-notify="dismiss">&times;</button>
                <span data-notify="icon"></span>
                <span data-notify="title">{1}</span>
                <span data-notify="message">{2}</span>
                <div class="progress" data-notify="progressbar" style="height: 5px;">
                    <div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
                </div>
                <a href="{3}" target="{4}" data-notify="url"></a>
            </div>`,
            z_index: 1051,
            delay: 10000
        });
    },
    msg: (m) => {
        console.info(m);
        $.notify({
            icon: 'fas fa-check-circle',
            message: m
        }, {
            type: "info",
            mouse_over: "pause",
            template: `<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert">
                <button type="button" aria-hidden="true" class="btn text-reset" data-notify="dismiss">&times;</button>
                <span data-notify="icon"></span>
                <span data-notify="title">{1}</span>
                <span data-notify="message">{2}</span>
                <div class="progress" data-notify="progressbar" style="height: 5px;">
                    <div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
                </div>
                <a href="{3}" target="{4}" data-notify="url"></a>
            </div>`,
            z_index: 1051,
            delay: 10000
        });
    },
    warn: (m) => {
        $.notify({
            icon: 'fas fa-check-circle',
            message: m
        }, {
            type: "warning",
            mouse_over: "pause",
            template: `<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert">
                <button type="button" aria-hidden="true" class="btn text-reset" data-notify="dismiss">&times;</button>
                <span data-notify="icon"></span>
                <span data-notify="title">{1}</span>
                <span data-notify="message">{2}</span>
                <div class="progress" data-notify="progressbar" style="height: 5px;">
                    <div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
                </div>
                <a href="{3}" target="{4}" data-notify="url"></a>
            </div>`,
            z_index: 1051,
            delay: 10000
        });
    }
}